import BaseApi from './BaseApi';

class ContactsApi extends BaseApi {
    get(query = null) {
        return this.requestGet(this.route('contacts.index'), query, {
            withCredentials: true,
        });
    }
}

export default ContactsApi;
